import {Component, EventEmitter, Input, Output} from '@angular/core';

import {TableActionEvent, TableParams, TableRow} from '../../../../shared';

import {AdjuntoTableColumn, AdjuntoTableParams,} from '../../../models';
import {ADJUNTO_TABLE_COLUMNS_DEFAULT} from "../../../constants";
import {createAdjuntoTableRow} from "../../../helpers";


@Component({
  selector: 'app-adjuntos-table',
  templateUrl: './adjuntos-table.component.html',
  styleUrls: ['./adjuntos-table.component.scss']
})
export class AdjuntosTableComponent {
  // aux
  columns: AdjuntoTableColumn[] = [];
  rows: TableRow[] = [];
  // output
  @Output() actioned = new EventEmitter<TableActionEvent>();
  tableParams: TableParams = {
    columns: [],
    values: []
  };

  constructor() {
  }

  // input
  private _params: AdjuntoTableParams = null;

  get params(): AdjuntoTableParams {
    return this._params;
  }

  @Input()
  set params(params: AdjuntoTableParams) {
    this._params = params;
    this.update();
  }

  update() {
    this.columns = [];
    this.rows = [];
    this.columns = this.params.columns || ADJUNTO_TABLE_COLUMNS_DEFAULT;
    this.updateRows();
    this.tableParams = {
      columns: this.columns.map(c => ({...c})),
      values: this.rows.map(r => ({...r})),
      filter: this.params.filter,
      pagination: this.params.pagination
    };
  }

  updateRows() {
    const rows: TableRow[] = [];
    if (this.params.adjuntos) {
      for (const adjunto of this.params.adjuntos) {
        rows.push(createAdjuntoTableRow(adjunto, this.columns, this.params.sources));
      }
    }
    this.rows = rows;
  }

  emit(action: TableActionEvent) {
    this.actioned.emit(action);
  }
}
